// Filtros de la pantalla Actividad de un agente: resultado, canal y periodo. Viajan en la dirección (?estado=error&canal=web&periodo=7d) para
// poder compartir una vista y para que no se pierdan al recargar. Lo que no se reconoce se ignora: una dirección vieja o mal escrita nunca rompe.

export const STATUS_FILTERS = [
  { key: '', label: 'Todas' },
  { key: 'ok', label: 'Respondidas' },
  { key: 'ignored', label: 'Sin responder' },
  { key: 'error', label: 'Con error' },
];
export const CHANNEL_FILTERS = [
  { key: '', label: 'Todos' },
  { key: 'web', label: 'Chat web' },
  { key: 'telegram', label: 'Telegram' },
  { key: 'whatsapp', label: 'WhatsApp' },
];
export const PERIODS = [
  { key: '', label: 'Todo lo guardado' },
  { key: 'hoy', label: 'Hoy' },
  { key: '24h', label: 'Últimas 24 horas' },
  { key: '7d', label: 'Últimos 7 días' },
  { key: '30d', label: 'Últimos 30 días' },
];

const MX_OFFSET = '-06:00';   // México ya no usa horario de verano (igual que costService)
const DAY = 86400000;

/** Desde cuándo (ISO) cubre un periodo; undefined = sin límite. «Hoy» empieza a la medianoche de la Ciudad de México. */
export function periodSince(key, now = new Date()) {
  if (key === '24h') return new Date(now.getTime() - DAY).toISOString();
  if (key === '7d') return new Date(now.getTime() - 7 * DAY).toISOString();
  if (key === '30d') return new Date(now.getTime() - 30 * DAY).toISOString();
  if (key === 'hoy') {
    const day = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City' }).format(now);   // AAAA-MM-DD en hora de México
    return new Date(`${day}T00:00:00${MX_OFFSET}`).toISOString();
  }
  return undefined;
}

const pick = (list, value) => (list.some((o) => o.key === value) ? value : '');

/** @returns {{ status: string, channel: string, period: string }} con '' = sin filtro. */
export function readFilters(params) {
  return {
    status: pick(STATUS_FILTERS, params.get('estado') || ''),
    channel: pick(CHANNEL_FILTERS, params.get('canal') || ''),
    period: pick(PERIODS, params.get('periodo') || ''),
  };
}

/** Escribe los filtros en la dirección conservando lo demás, salvo `t` (la interacción abierta: puede no estar en la vista nueva). */
export function writeFilters(params, f) {
  const next = new URLSearchParams(params);
  next.delete('t');
  for (const [name, value] of [['estado', f.status], ['canal', f.channel], ['periodo', f.period]]) {
    if (value) next.set(name, value); else next.delete(name);
  }
  return next;
}

export const hasFilters = (f) => Boolean(f.status || f.channel || f.period);

/** Una frase con lo que se está viendo, para quien lee con lector de pantalla y para el estado vacío. */
export function describeFilters(f) {
  const parts = [];
  if (f.channel) parts.push(CHANNEL_FILTERS.find((o) => o.key === f.channel).label);
  if (f.status) parts.push(STATUS_FILTERS.find((o) => o.key === f.status).label.toLowerCase());
  if (f.period) parts.push(PERIODS.find((o) => o.key === f.period).label.toLowerCase());
  return parts.join(' · ');
}

/**
 * Contadores de cada botón a partir de las filas agrupadas de agent_trace_counts ([{ status, channel, n }]). Cada grupo cuenta con LOS DEMÁS
 * filtros aplicados: los botones de resultado respetan el canal elegido y los de canal respetan el resultado elegido; así el número de un
 * botón es justo lo que se vería al pulsarlo. El periodo ya viene aplicado en la consulta.
 */
export function countsFor(rows, f) {
  const status = { '': 0, ok: 0, ignored: 0, error: 0 };
  const channel = { '': 0, web: 0, telegram: 0, whatsapp: 0 };
  for (const r of rows || []) {
    const n = Number(r.n) || 0;
    if (!f.channel || r.channel === f.channel) { status[''] += n; if (r.status in status) status[r.status] += n; }
    if (!f.status || r.status === f.status) { channel[''] += n; if (r.channel in channel) channel[r.channel] += n; }
  }
  return { status, channel };
}
